/**
 * Single source of truth for Firebase web + FCM client config.
 *
 * IMPORTANT: `public/firebase-messaging-sw.js` duplicates `firebaseConfig`
 * (service workers cannot import this module). After editing here, update
 * the SW file to match apiKey, projectId, messagingSenderId, and appId.
 *
 * VAPID key: Firebase Console → Project Settings → Cloud Messaging →
 * Web Push certificates → Key pair (public key).
 */
export const firebaseConfig = {
  apiKey: "AIzaSyAo318dbwXhdbx27b5RtPy6affE3_w6C6U",
  authDomain: "sattva-ats-fcm-706d9.firebaseapp.com",
  projectId: "sattva-ats-fcm-706d9",
  storageBucket: "sattva-ats-fcm-706d9.firebasestorage.app",
  messagingSenderId: "1029598810618",
  appId: "1:1029598810618:web:9ac00091c7fb2ac33c5443",
  measurementId: "G-R091DWDWQ5"
}

/** Web Push VAPID public key — must match Firebase Console key pair for this project. */
export const FCM_VAPID_KEY = 'BCrC2btizhQR4DMjYFnS8aqHNgxava3Ozde0tOO7cO-LrIZEiUHhLdqaKFqoaazrN3T731iUmHw8O081PfR-BQY'

/**
 * Service worker at site root (public/firebase-messaging-sw.js).
 * Query bump forces browsers to re-fetch after we switched off gstatic CDN
 * (CSP script-src 'self' blocks importScripts to www.gstatic.com).
 * Keep in sync with the VERSION comment inside public/firebase-messaging-sw.js.
 */
export const FCM_SW_SCRIPT_URL = '/firebase-messaging-sw.js?v=vendor-2'

export const FCM_SW_SCOPE = '/'
